import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
const apihomeurl = "https://v3.explorug.com/";
const apilogurl = `${apihomeurl}Beyonddreamsapp/log.aspx`;
let sessionkey = "";

const logData = async (action,log) => {
  if(!sessionkey || sessionkey === ""){
    await makeSessionKey();
  }  
  console.log(sessionkey);
  const data = new FormData();
  data.append("action", action);
  data.append("log", log);
  data.append("id", sessionkey);
  axios.post(apilogurl, data).then((returndata)=>{
    console.log("success");
  })
}

const makeSessionKey = () => {
  let longuuid = uuidv4();
  sessionkey = longuuid.split("-")[0];
  return Promise.resolve();
}

const getSessionKey = () => {
  return sessionkey;
}

const Api = {
  logData,
  getSessionKey
};
export default Api;